// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "public/js/" + {"97":"org0","601":"components0","608":"tribes0"}[chunkId] + "." + {"97":"39812043","601":"14bf8fa5","608":"6e360a47"}[chunkId] + ".js";
};